import type { CrossBorderReceiverRequest } from '../../../../generated-types';
import { CrossBorderPaymentState } from './state';

const createReceiverRequest = (state: CrossBorderPaymentState): CrossBorderReceiverRequest => {
    const bank = state.bankValidation?.routingBicBank || state.bankValidation?.bank;
    const nationalId = state.receiver?.nationalId || bank?.nationalId;

    return {
        account: { number: state.receiver!.accountNumber!, type: state.receiver!.accountType! },
        address: state.receiver?.address,
        address2: state.receiver?.address2 === '' ? ' ' : state.receiver?.address2,
        town: state.receiver?.town,
        postcode: state.receiver?.postcode,
        bank: {
            bic: bank?.bic,
            countryCode: bank!.countryCode!,
            nationalId: !state.country?.nationalIdRequirements?.required && !!bank?.bic ? undefined : nationalId,
            name: bank?.name,
        },
        countryCode: state.receiver?.receiverCountryCode,
        name: state.receiverName! || state.receiver!.name!,
        deviceId: window.ReactNativeProps?.deviceId,
    };
};

export default createReceiverRequest;
